export default __webpack_public_path__ + "static/media/animation_placeholder.8edf022b.png";